import { get } from './apiClient';

/**
 * Fetch Admin Dashboard Statistics (KPIs)
 * @returns {Promise<Object>} Dashboard statistics
 */
export const fetchAdminDashboardStats = async () => {
    try {
        const response = await get('/dashboard/admin-stats');
        return response.data;
    } catch (error) {
        throw error;
    }
};
